import { API_URL } from '../../shared/clientHttp';
import Avatar from '@mui/joy/Avatar';
import Box from '@mui/joy/Box';

import { avatarGradient, initialsOf, CHAT } from './chatTheme';

/**
 * Аватар с инициалами и цветом, выведенным из имени.
 *
 * Раньше это был пустой серый кружок у всех подряд — в списке из тысячи
 * чатов их невозможно было различить глазом. Теперь цвет стабильно привязан
 * к имени: один и тот же человек везде одного цвета.
 */
export default function AvatarWithStatus({
  online = false,
  showStatus = false,
  name,
  alt,
  size = 'md',
  src,
  person,
  sx,
  ...other
}) {
  const label = name || alt || '';
  let photo;
  try {
    const raw = src || person?.avatar_url;
    if (typeof raw === 'string' && raw) {
      const url = new URL(raw, API_URL.replace(/\/$/, '') + '/');
      if (['https:', 'http:'].includes(url.protocol) && !url.username && !url.password) photo = url.href;
    }
  } catch (_) {}

  const px = size === 'sm' ? CHAT.avatarSm : size === 'lg' ? CHAT.avatarLg : CHAT.avatarMd;

  const avatar = (
    <Avatar
      src={photo}
      alt={label}
      {...other}
      sx={{
        width: px,
        height: px,
        fontWeight: 700,
        fontSize: px <= 34 ? 13 : px >= 72 ? 30 : 15,
        color: '#fff',
        letterSpacing: '0.02em',
        background: avatarGradient(label),
        borderRadius: '50%',
        flexShrink: 0,
        ...sx,
      }}
    >
      {initialsOf(label)}
    </Avatar>
  );

  if (!showStatus) return avatar;

  // Точка «на связи». Раньше это был бледный бейдж Joy — на белой шапке его
  // почти не было видно. Теперь яркий зелёный кружок с пульсирующим ореолом:
  // сигнал читается боковым зрением, как индикатор связи и должен.
  const dot = Math.max(9, Math.round(px * 0.26));

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex', flexShrink: 0 }}>
      {avatar}
      <Box
        sx={{
          position: 'absolute',
          right: -1,
          bottom: -1,
          width: dot,
          height: dot,
          borderRadius: '50%',
          backgroundColor: online ? '#22c55e' : '#94a3b8',
          border: '2px solid var(--joy-palette-background-surface, #fff)',
          boxShadow: online ? '0 0 0 0 rgba(34,197,94,0.55)' : 'none',
          animation: online ? 'chatPulse 1.9s ease-out infinite' : 'none',
          '@keyframes chatPulse': {
            '0%':   { boxShadow: '0 0 0 0 rgba(34,197,94,0.55)' },
            '70%':  { boxShadow: '0 0 0 7px rgba(34,197,94,0)' },
            '100%': { boxShadow: '0 0 0 0 rgba(34,197,94,0)' },
          },
        }}
      />
    </Box>
  );
}
